






import { Component, Vue } from "vue-property-decorator";
import HacoAuth from "@/components/HacoAuth.vue";
@Component({
  components: {
    HacoAuth
  }
})
export default class App extends Vue {
  // put something
}
